var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1792.13 200.13",
    style: {
      enableBackground: "new 0 0 1792.13 200.13"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010202;}\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1180.22,
    cy: 24.44,
    r: 12.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.27,40.79v147.38H34.62V40.79H2.36v-14.6h86.17v14.6H56.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.4,188.17V98.23c0-13.18-5.65-24.96-25.9-24.96c-9.42,0-16.95,1.65-24.72,6.36v108.53h-20.72V3.36h20.72 v64.51c10.59-5.41,19.78-7.77,29.19-7.77c32.25,0,42.14,19.54,42.14,37.43v90.64H175.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.9,132.61c2.35,28.72,15.77,42.85,38.61,42.85c14.36,0,24.72-3.53,31.31-7.3l5.41,13.65 c-7.77,4.71-21.19,8.71-38.37,8.71c-33.2,0-56.5-20.95-56.5-66.16c0-43.08,21.19-65.45,51.09-65.45 c30.37,0,48.73,19.78,48.26,62.15L235.9,132.61z M266.74,72.34c-18.36,0-32.02,14.83-31.55,49.2l60.74-9.18 C295.94,83.64,284.87,72.34,266.74,72.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M388.44,190.75V27.7h21.8v163.06H388.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M509.78,190.75V99.04c0-11.85-4.98-24.88-26.78-24.88c-11.85,0-17.54,1.66-24.17,4.5v112.1h-20.86V69.65 c11.38-5.45,26.31-9.01,46.69-9.01c35.55,0,45.98,19.67,45.98,37.92v92.19H509.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M583.49,76.05v114.71h-20.86V76.05h-14.69V63.01h14.69V45c0-25.12,15.17-41.47,43.13-40.29v13.27 c-12.56,0.71-22.28,6.64-22.28,24.65v20.38h22.28v13.03H583.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M663.36,193.12c-34.84,0-50.01-28.68-50.01-66.12c0-38.16,15.4-66.36,49.77-66.36 c35.08,0,50.01,28.2,50.01,66.36C713.13,164.45,697.96,193.12,663.36,193.12z M663.36,73.91c-24.41,0-29.15,27.25-29.15,53.09 s5.21,51.67,29.15,51.67c24.41,0,28.91-26.07,28.91-51.67C692.27,101.41,687.77,73.91,663.36,73.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M783.51,76.76c-10.43-3.08-22.28-2.13-29.15,2.37v111.63h-20.86V69.89c12.56-6.4,24.65-9.72,54.98-9.01 L783.51,76.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M945.15,190.75V98.8c0-12.8-6.16-24.41-24.65-24.41c-10.67,0-18.96,3.56-26.31,11.38v104.99h-20.86v-92.9 c0-14.22-9.48-23.7-27.97-23.7c-10.43,0-16.12,1.42-22.99,4.27v112.34h-20.86V69.65c11.61-5.69,23.94-9.01,44.32-9.01 c19.67,0,31.52,5.93,39.11,15.4c8.77-9.24,21.8-15.4,39.58-15.4c30.57,0,41.47,19.91,41.47,37.68v92.43H945.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1033.55,193.12c-33.18,0-48.59-14.46-48.59-37.68c0-33.89,31.76-43.84,71.34-47.87v-7.82 c0-19.67-11.85-25.36-28.2-25.36c-12.32,0-23.7,4.5-30.81,8.06l-4.98-12.32c7.35-4.03,21.57-9.48,39.1-9.48 c23.7,0,44.56,10.19,44.56,41.48v82C1066.25,189.57,1051.32,193.12,1033.55,193.12z M1056.3,118.23 c-32.23,4.03-51.43,10.9-51.43,36.73c0,18.49,11.38,26.07,30.34,26.07c8.06,0,15.88-1.42,21.09-4.27V118.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1138.78,191.94c-23.23,0-31.76-16.59-31.76-32.23V76.05h-14.69V63.01h14.69V33.62l20.86-6.4v35.79h22.28 v13.03h-22.28v83.19c0,10.19,4.5,18.49,16.12,18.49c2.13,0,4.03-0.47,6.16-0.95v13.27 C1147.78,190.75,1143.99,191.94,1138.78,191.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1169.11,190.75V63.01h20.86v127.74H1169.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1261.54,193.12c-34.84,0-50.01-28.68-50.01-66.12c0-38.16,15.41-66.36,49.77-66.36 c35.08,0,50.01,28.2,50.01,66.36C1311.31,164.45,1296.14,193.12,1261.54,193.12z M1261.54,73.91c-24.41,0-29.15,27.25-29.15,53.09 s5.21,51.67,29.15,51.67c24.41,0,28.91-26.07,28.91-51.67C1290.45,101.41,1285.95,73.91,1261.54,73.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1403.5,190.75V99.04c0-11.85-4.98-24.88-26.78-24.88c-11.85,0-17.54,1.66-24.17,4.5v112.1h-20.86V69.65 c11.38-5.45,26.31-9.01,46.69-9.01c35.55,0,45.98,19.67,45.98,37.92v92.19H1403.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1498.96,190.75V27.7h21.8v148.36h49.06v14.69H1498.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1628.12,193.12c-33.18,0-48.58-14.46-48.58-37.68c0-33.89,31.76-43.84,71.34-47.87v-7.82 c0-19.67-11.85-25.36-28.2-25.36c-12.32,0-23.7,4.5-30.81,8.06l-4.98-12.32c7.35-4.03,21.57-9.48,39.1-9.48 c23.7,0,44.56,10.19,44.56,41.48v82C1660.83,189.57,1645.9,193.12,1628.12,193.12z M1650.88,118.23 c-32.23,4.03-51.43,10.9-51.43,36.73c0,18.49,11.38,26.07,30.34,26.07c8.06,0,15.88-1.42,21.09-4.27V118.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1734.06,193.12c-17.3,0-30.57-4.03-38.16-9.01V4.71h20.62v62.57c6.4-3.32,13.51-5.93,26.07-5.93 c29.39,0,49.53,24.65,49.53,63.28C1792.13,165.63,1771.98,193.12,1734.06,193.12z M1737.38,73.68c-9.48,0-14.93,1.66-20.86,4.98 v97.88c4.74,2.37,11.38,3.08,18.01,3.08c26.31,0,36.73-22.04,36.73-54.27C1771.27,97.38,1761.55,73.68,1737.38,73.68z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4f342cd269b3c5dbe4b32289ad00a371.svg";
export { ForwardRef as ReactComponent };